import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AppRole } from '../auth/app-role.enum';
import { AuthService } from '../auth/auth.service';

export const roleGuard: CanActivateFn = async () => {
  const userService = inject(AuthService);
  const router = inject(Router);

  if (!userService.isAuthenticated()) {
    return router.createUrlTree(['/auth/login']);
  }

  const roles = await userService.getUserRoles();

  if (roles.includes(AppRole.BackOfficeAdmin)) {
    return true;
  }

  return router.createUrlTree(['/auth/error']);
};
